import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=056f8224&scoped=true&"
import script from "./TheHeader.vue?vue&type=script&lang=ts&"
export * from "./TheHeader.vue?vue&type=script&lang=ts&"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=056f8224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f8224",
  null
  
)

export default component.exports